import { timezone, dateformat } from "../config"
import moment from "moment-timezone"

export const convertUtcToLocal = (custdate, format = "YYYY-MM-DD") => {
  const mydate = moment.utc(custdate)
  if (mydate.isValid()) {
    return timezone
      ? mydate.tz(timezone).format(format)
      : mydate.local().format(format)
  } else {
    return custdate
  }
}

export const convertDateToUtc = custdate => {
  if (custdate) {
    return moment.tz(custdate, timezone).utc().format()
  }
}
